import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

interface MonthlyBillingModel {
  module: string;
  features: string[];
  forms: string[];
  systemAction: string[];
  benefits: string[];
  kpi: string;
}

@Component({
  selector: 'app-monthly-billing-list',
  templateUrl: './monthly-billing-list.component.html',
  styleUrl: './monthly-billing-list.component.css'
})
export class MonthlyBillingListComponent implements OnInit {
  displayedColumns: string[] = ['module', 'features', 'forms', 'systemAction', 'benefits', 'kpi'];
  dataSource!: MatTableDataSource<MonthlyBillingModel>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dummyData: MonthlyBillingModel[] = [
    {
      module: 'Monthly Billing',
      features: ['Monthly billing calculation', 'Invoice generation'],
      forms: ['Billing form', 'Invoice form'],
      systemAction: ['System calculates monthly billing', 'Generates invoice'],
      benefits: ['Accurate billing system', 'Scalability'],
      kpi: 'Monthly billing cycle adherence'
    },
    {
      module: 'Subscription Billing',
      features: ['Auto-renewal', 'Discount calculation'],
      forms: ['Subscription form'],
      systemAction: ['System renews subscriptions automatically'],
      benefits: ['User convenience', 'Revenue assurance'],
      kpi: 'Subscription renewal success rate'
    },
    {
      module: 'Utility Billing',
      features: ['Consumption-based billing', 'Tiered pricing'],
      forms: ['Utility bill', 'Customer usage form'],
      systemAction: ['Calculates based on usage'],
      benefits: ['Fair billing', 'Customer satisfaction'],
      kpi: 'Billing accuracy rate'
    }
  ];

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.dummyData);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  stringify(array: string[]): string {
    return array.join(', ');
  }
}